import type { FC } from 'react'

import styled from '@emotion/styled'

import HeroBase, * as HeroRecipe from '@segment/matcha/recipes/Hero'
import CopyTextBase, * as CopyText from '@segment/matcha/recipes/CopyText'
import SignupButton from '@segment/matcha/recipes/SignupButton'

import HeroImage from './HeroImage'

const copy = {
  heading: `Developer Toolkit`,
  description: `Learn how to take your customer data infrastructure to the next level with free guides, open source tools, recipes, and product documentation.`,
  cta: {
    title: `Sign up for free`,
  },
}

const Hero: FC = () => {
  return (
    <Wrapper>
      <HeroBase variant="2Col">
        <HeroRecipe.Copy>
          <CopyTextBase>
            <CopyText.Heading tag="h1" variant="h1">
              {copy.heading}
            </CopyText.Heading>
            <CopyText.Description tag="p" variant="pExtraLarge">
              {copy.description}
            </CopyText.Description>
            <StyledButton>{copy.cta.title}</StyledButton>
          </CopyTextBase>
        </HeroRecipe.Copy>
        <HeroRecipe.Contents>
          <HeroImage alt={`Illustration: ${copy.heading}`} />
        </HeroRecipe.Contents>
      </HeroBase>
    </Wrapper>
  )
}

const StyledButton = styled(SignupButton)`
  ${({ theme }) => theme.breakpoints.up(`md`)} {
    margin-top: 20px;
  }
`

const Wrapper = styled.header`
  background: ${({ theme }) => theme.palette.twilio.green[10]};
`

export default Hero
